import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';
import { profileChoiceOptions } from '@/platform/features/profile/profile-choice-options';
import { useProfileEdit } from '@/platform/features/profile/profile-edit-context';
import { USER_JOB_TITLE_LABEL } from '@/platform/features/users/user-labels';
import { useOwnProfileOptions } from '@/platform/features/users/use-own-profile';

/** Stellenbezeichnung, Abteilung, Standort und „Über mich“ — Speichern über die Profilseite. */
export function ProfilePublicFields() {
  const { profile, jobTitle, setJobTitle, siteId, setSiteId, aboutMe, setAboutMe } =
    useProfileEdit();
  const options = useOwnProfileOptions();
  const optionsFailed = options.isError;
  const siteChoices = profileChoiceOptions(
    options.data?.sites,
    profile.siteId,
    profile.siteName,
    profile.siteActive,
  );

  return (
    <div className="space-y-4">
      {optionsFailed ? (
        <p role="alert" className="text-sm text-destructive">
          Die Auswahllisten konnten nicht geladen werden.
        </p>
      ) : null}
      <div>
        <Label htmlFor="profile-job-title">{USER_JOB_TITLE_LABEL}</Label>
        <Input
          id="profile-job-title"
          className="mt-2"
          value={jobTitle}
          autoComplete="organization-title"
          maxLength={120}
          onChange={(event) => setJobTitle(event.target.value)}
        />
      </div>
      <div>
        <Label htmlFor="profile-department">Abteilung</Label>
        <Input
          id="profile-department"
          className="mt-2"
          value={profile.departmentName ?? 'Keine Abteilung'}
          readOnly
        />
        <p className="mt-1.5 text-xs text-muted-foreground">
          Die Abteilung setzt die Verwaltung. Sie steuert, welche Beiträge sichtbar sind.
        </p>
      </div>
      <div>
        <Label htmlFor="profile-site">Standort</Label>
        <Select
          value={siteId || 'none'}
          disabled={optionsFailed || options.isPending}
          onValueChange={(value) => setSiteId(value === 'none' ? '' : value)}
        >
          <SelectTrigger id="profile-site" className="mt-2 w-full">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="none">Kein Standort</SelectItem>
            {siteChoices.map((item) => (
              <SelectItem key={item.id} value={item.id} disabled={item.disabled}>
                {item.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label htmlFor="profile-about">Über mich</Label>
        <Textarea
          id="profile-about"
          className="mt-2"
          maxLength={500}
          value={aboutMe}
          onChange={(event) => setAboutMe(event.target.value)}
        />
        <p className="mt-1.5 text-xs text-muted-foreground">
          Sichtbar für Kolleginnen und Kollegen.
        </p>
      </div>
    </div>
  );
}
